import React, { Component } from 'react';
import config from 'react-global-configuration';

class Loading extends Component {

  // constructor
  constructor(props) {
    super(props);
    this.state = {
      style: {opacity: 0, display: 'none'},
      opacidade: 0,
    };

    this.aumentar_opacidade = this.aumentar_opacidade.bind(this);
    this.abrir = this.abrir.bind(this);
    this.diminuir_opacidade = this.diminuir_opacidade.bind(this);
    this.fechar = this.fechar.bind(this);
  }

  componentDidMount() {
    if (this.props.ativo == 1) {
      this.setState({
        style: {opacity: 0, display: 'none'},
         opacidade: 0,
      });
      setTimeout(() => {this.abrir();}, 50);      
    }
    if (this.props.ativo == 2) {
      this.setState({
        style: {opacity: 1, display: 'block'},
        opacidade: 1,
      });
      setTimeout(() => {this.fechar();}, 50);      
    }
  }

  componentWillReceiveProps(newProps) {
    if (newProps.ativo == 1) {
      this.setState({
        style: {opacity: 0, display: 'none'},
         opacidade: 0,
      });
      setTimeout(() => {this.abrir();}, 50);      
    }
    if (newProps.ativo == 2) {
      this.setState({
        style: {opacity: 1, display: 'block'},
        opacidade: 1,
      });
      setTimeout(() => {this.fechar();}, 50);      
    }
  }

  diminuir_opacidade() {
    var opacidade = this.state.style.opacity;
    opacidade = opacidade - 0.1;
    this.setState({style: {opacity: opacidade, display: 'block'}});
    this.setState({opacidade: opacidade});
  }

  fechar() {
    var interromper = setInterval(this.diminuir_opacidade, 15);
    setTimeout(() => {clearInterval(interromper); this.setState({style: {opacity: 0, display: 'none'}}); this.props.desativar(); }, 150);
  }

  aumentar_opacidade() {
    var opacidade = this.state.style.opacity;
    opacidade = opacidade + 0.1;
    this.setState({style: {opacity: opacidade, display: 'block'}});
    this.setState({opacidade: opacidade});
  }

  abrir() {
    var interromper = setInterval(this.aumentar_opacidade, 15);
    setTimeout(() => {clearInterval(interromper); this.setState({style: {opacity: 1, display: 'block'}});}, 150);
  }


  render() {
    return (
<div className="loading" style={this.state.style}>
  <div className="loading-spinning">
    <i className="fa fa-fw fa-spinner fa-spin"></i>
    <br/>
    <p className="loading-text"><span>Carregando...</span></p>
  </div>
</div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Components/Miscelania/Loading.js